import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { OptionDefinition } from './SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from './SortOptionsHelper';

export namespace SortOptions {
  export const hits: OptionDefinition = {
    id: 'hits',
    getMenuItemDisplayValue: Messages.viewedByUsers,
    subSortOptions: {
      '1month': {
        id: 'hits.1month',
        field: OrderKeys.hitsLastOneMonthTotal,
        getMenuItemDisplayValue: Messages.abbr_hitsLastOneMonthTotal,
        getButtonDisplayValue: Messages.sortByHitsLastOneMonthTotal,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.hitsLastOneMonthTotal), Order.asc(OrderKeys.name)],
        subSortOptions: {
          'asc': {
            id: 'hits.1month.asc',
            field: OrderKeys.hitsLastOneMonthTotal,
            ascending: true,
            getMenuItemDisplayValue: Messages.abbr_hitsLastOneMonthTotal
          }
        }
      },
      '3months': {
        id: 'hits.3months',
        field: OrderKeys.hitsLastThreeMonthsTotal,
        getMenuItemDisplayValue: Messages.abbr_hitsLastThreeMonthsTotal,
        getButtonDisplayValue: Messages.sortByHitsLastThreeMonthsTotal,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.hitsLastThreeMonthsTotal), Order.asc(OrderKeys.name)],
        subSortOptions: {
          'asc': {
            id: 'hits.3months.asc',
            field: OrderKeys.hitsLastThreeMonthsTotal,
            ascending: true,
            getMenuItemDisplayValue: Messages.abbr_hitsLastThreeMonthsTotal
          }
        }
      },
      '12months': {
        id: 'hits.12months',
        field: OrderKeys.hitsLastTwelveMonthsTotal,
        getMenuItemDisplayValue: Messages.abbr_hitsLastTwelveMonthsTotal,
        getButtonDisplayValue: Messages.sortByHitsLastTwelveMonthsTotal,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.hitsLastTwelveMonthsTotal), Order.asc(OrderKeys.name)],
        subSortOptions: {
          'asc': {
            id: 'hits.12months.asc',
            field: OrderKeys.hitsLastTwelveMonthsTotal,
            ascending: true,
            getMenuItemDisplayValue: Messages.abbr_hitsLastTwelveMonthsTotal
          }
        }
      },
      'total': {
        id: 'hits.allTime',
        field: OrderKeys.hitsTotal,
        getMenuItemDisplayValue: Messages.abbr_hitsTotal,
        getButtonDisplayValue: Messages.sortByHitsTotal,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.hitsTotal), Order.asc(OrderKeys.name)],
        subSortOptions: {
          'asc': {
            id: 'hits.allTime.asc',
            field: OrderKeys.hitsTotal,
            ascending: true,
            getMenuItemDisplayValue: Messages.column_hitsTotal
          }
        }
      }
    }
  };

  export const name: OptionDefinition = {
    id: 'name',
    getMenuItemDisplayValue: Messages.column_name,
    subSortOptions: {
      'asc': {
        id: 'name.asc',
        field: OrderKeys.name,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByNameAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.name)]
      },
      'desc': {
        id: 'name.desc',
        field: OrderKeys.name,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByNameDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.name)]
      }
    }
  };

  export const createdAt: OptionDefinition = {
    id: 'created',
    getMenuItemDisplayValue: Messages.column_created,
    subSortOptions: {
      'desc': {
        id: 'created.desc',
        field: OrderKeys.createdAt,
        getMenuItemDisplayValue: Messages.sortByNewest,
        getButtonDisplayValue: Messages.sortByCreatedNewest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.createdAt)]
      },
      'asc': {
        id: 'created.asc',
        field: OrderKeys.createdAt,
        getMenuItemDisplayValue: Messages.sortByOldest,
        getButtonDisplayValue: Messages.sortByCreatedOldest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.createdAt)]
      }
    }
  };

  export const createdTime: OptionDefinition = {
    id: 'createdTime',
    getMenuItemDisplayValue: Messages.column_created,
    subSortOptions: {
      'desc': {
        id: 'createdTime.desc',
        field: OrderKeys.createdTime,
        getMenuItemDisplayValue: Messages.sortByNewest,
        getButtonDisplayValue: Messages.sortByCreatedNewest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.createdTime)]
      },
      'asc': {
        id: 'createdTime.asc',
        field: OrderKeys.createdTime,
        getMenuItemDisplayValue: Messages.sortByOldest,
        getButtonDisplayValue: Messages.sortByCreatedOldest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.createdTime)]
      }
    }
  };

  export const owner: OptionDefinition = {
    id: 'owner',
    getMenuItemDisplayValue: Messages.column_owner,
    subSortOptions: {
      'asc': {
        id: 'owner.asc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByOwnerAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.ownerName), Order.asc(OrderKeys.name)]
      },
      'desc': {
        id: 'owner.desc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByOwnerDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.ownerName), Order.asc(OrderKeys.name)]
      }
    }
  };

  export const modifiedBy: OptionDefinition = {

    id: 'modifiedBy',
    getMenuItemDisplayValue: Messages.modifiedBy,
    subSortOptions: {
      'asc': {
        id: 'modifiedBy.asc',
        field: OrderKeys.modifiedBy,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByModifiedByAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.modifiedBy)]
      },
      'desc': {
        id: 'modifiedBy.desc',
        field: OrderKeys.modifiedBy,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByModifiedByDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.modifiedBy)]
      }
    }
  };

  // Same as owner but includes content type as secondary sort
  export const mixedContentOwner: OptionDefinition = {
    id: 'owner',
    getMenuItemDisplayValue: Messages.column_owner,
    subSortOptions: {
      'asc': {
        id: 'owner.asc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByOwnerAsc,
        ascending: true,
        toOrderClauseArray: () => [{field: OrderKeys.ownerName, ascending: true},{field: OrderKeys.contentTypeOrder, ascending: true},{field: OrderKeys.name, ascending: true}]
      },
      'desc': {
        id: 'owner.desc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByOwnerDesc,
        ascending: false,
        toOrderClauseArray: () => [{field: OrderKeys.ownerName, ascending: false},{field: OrderKeys.contentTypeOrder, ascending: true},{field: OrderKeys.name, ascending: true}]
      }
    }
  };

  export const updated: OptionDefinition = {
    id: 'updated',
    getMenuItemDisplayValue: Messages.column_updated,
    subSortOptions: {
      'desc': {
        id: 'updated.desc',
        field: OrderKeys.updatedAt,
        getMenuItemDisplayValue: Messages.sortByNewest,
        getButtonDisplayValue: Messages.sortByUpdatedNewest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.updatedAt)]
      },
      'asc': {
        id: 'updated.asc',
        field: OrderKeys.updatedAt,
        getMenuItemDisplayValue: Messages.sortByOldest,
        getButtonDisplayValue: Messages.sortByUpdatedOldest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.updatedAt)]
      }
    }
  };

  export const updatedTime: OptionDefinition = {
    id: 'updatedTime',
    getMenuItemDisplayValue: Messages.column_updated,
    subSortOptions: {
      'desc': {
        id: 'updatedTime.desc',
        field: OrderKeys.updatedTime,
        getMenuItemDisplayValue: Messages.sortByNewest,
        getButtonDisplayValue: Messages.sortByUpdatedNewest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.updatedTime)]
      },
      'asc': {
        id: 'updatedTime.asc',
        field: OrderKeys.updatedTime,
        getMenuItemDisplayValue: Messages.sortByOldest,
        getButtonDisplayValue: Messages.sortByUpdatedOldest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.updatedTime)]
      }
    }
  };

  export const alert: OptionDefinition = {
    id: 'alert',
    getMenuItemDisplayValue: Messages.alert,
    subSortOptions: {
      'asc': {
        id: 'alert.asc',
        field: OrderKeys.hasAlert,
        getMenuItemDisplayValue: Messages.sortByHasAlert,
        getButtonDisplayValue: Messages.alert,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.hasAlert), Order.asc(OrderKeys.name)]
      },
      'desc': {
        id: 'alert.desc',
        field: OrderKeys.hasAlert,
        getMenuItemDisplayValue: Messages.sortByHasNoAlert,
        getButtonDisplayValue: Messages.alert,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.hasAlert), Order.asc(OrderKeys.name)]
      }
    }
  };

  export const projectName: OptionDefinition = {
    id: 'projectName',
    getMenuItemDisplayValue: Messages.project,
    subSortOptions: {
      'asc': {
        id: 'projectName.asc',
        field: OrderKeys.projectName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByProjectAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.projectName), Order.asc(OrderKeys.name)]
      },
      'desc': {
        id: 'projectName.desc',
        field: OrderKeys.projectName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByProjectDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.projectName), Order.asc(OrderKeys.name)]
      }
    }
  };

  export const containerName: OptionDefinition = {
    id: 'containerName',
    getMenuItemDisplayValue: Messages.column_location,
    subSortOptions: {
      'asc': {
        id: 'containerName.asc',
        field: OrderKeys.containerName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByLocationAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.containerName), Order.asc(OrderKeys.name)]
      },
      'desc': {
        id: 'containerName.desc',
        field: OrderKeys.containerName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByLocationDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.containerName), Order.asc(OrderKeys.name)]
      }
    }
  };

  export const datasourceRefresh: OptionDefinition = {
    id: 'refresh',
    getMenuItemDisplayValue: Messages.sortByLastRefreshedAt,
    subSortOptions: {
      'desc': {
        id: 'refresh.desc',
        field: OrderKeys.lastRefreshedAt,
        getMenuItemDisplayValue: Messages.sortByNewOld,
        getButtonDisplayValue: Messages.sortByLastRefreshedAtDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.lastRefreshedAt)]
      },
      'asc': {
        id: 'refresh.asc',
        field: OrderKeys.lastRefreshedAt,
        getMenuItemDisplayValue: Messages.sortByOldNew,
        getButtonDisplayValue: Messages.sortByLastRefreshedAtAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.lastRefreshedAt), Order.asc(OrderKeys.name)]
      }
    }
  };

  export const sheetIndex: OptionDefinition = {
    id: 'sheet',
    getMenuItemDisplayValue: Messages.column_sheetNumber,
    subSortOptions: {
      'asc': {
        id: 'sheet.asc',
        field: OrderKeys.index,
        getMenuItemDisplayValue: Messages.sortByFirstLast,
        getButtonDisplayValue: Messages.sortBySheetNumberAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.index), Order.asc(OrderKeys.name)]
      },
      'desc': {
        id: 'sheet.desc',
        field: OrderKeys.index,
        getMenuItemDisplayValue: Messages.sortByLastFirst,
        getButtonDisplayValue: Messages.sortBySheetNumberDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.index), Order.asc(OrderKeys.name)]
      }
    }
  };

  export const connectionType: OptionDefinition = {
    id: 'connection-type',
    getMenuItemDisplayValue: Messages.column_connection_type,
    subSortOptions: {
      'asc': {
        id: 'connection-type.asc',
        field: OrderKeys.connectionTypeDisplayName,
        ascending: true,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByConnectionTypeAsc,
        toOrderClauseArray: () => [Order.asc(OrderKeys.connectionTypeDisplayName)]
      },
      'desc': {
        id: 'connection-type.desc',
        field: OrderKeys.connectionTypeDisplayName,
        ascending: false,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByConnectionTypeDesc,
        toOrderClauseArray: () => [Order.desc(OrderKeys.connectionTypeDisplayName)]
      }
    }
  };

  export const relevance: OptionDefinition = {
    id: OrderKeys.relevance,
    field: OrderKeys.relevance,
    getMenuItemDisplayValue: Messages.relevance,
    getButtonDisplayValue: Messages.relevance,
    ascending: false,
    toOrderClauseArray: () => [Order.desc(OrderKeys.relevance)]
  };

  export const runNextAt: OptionDefinition = {
    id: OrderKeys.runNextAt,
    getMenuItemDisplayValue: Messages.column_task_next_update,
    subSortOptions: {
      'asc': {
        id: 'runNextAt.asc',
        field: OrderKeys.runNextAt,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.runNextAt)]
      },
      'desc': {
        id: 'runNextAt.desc',
        field: OrderKeys.runNextAt,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.runNextAt)]
      }
    }
  };

  export const lastRunAt: OptionDefinition = {
    id: OrderKeys.lastRunAt,
    getMenuItemDisplayValue: Messages.column_task_last_update,
    subSortOptions: {
      'asc': {
        id: 'lastRunAt.asc',
        field: OrderKeys.lastRunAt,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.lastRunAt)]
      },
      'desc': {
        id: 'lastRunAt.desc',
        field: OrderKeys.lastRunAt,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.lastRunAt)]
      }
    }
  };

  export const siteName = createNonDisplayOptionDefinition('siteName', OrderKeys.siteName);

  export const schedule: OptionDefinition = {
    id: OrderKeys.scheduleName,
    getMenuItemDisplayValue: Messages.column_task_schedule,
    subSortOptions: {
      'asc': {
        id: 'scheduleName.asc',
        field: OrderKeys.scheduleName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.scheduleName)]
      },
      'desc': {
        id: 'scheduleName.desc',
        field: OrderKeys.scheduleName,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.scheduleName)]
      }
    }
  };

  export const type: OptionDefinition = {
    id: 'type.asc',
    field: OrderKeys.contentTypeOrder,
    getMenuItemDisplayValue: Messages.column_content_type,
    getButtonDisplayValue: Messages.column_content_type,
    ascending: true,
    toOrderClauseArray: () => [{field: OrderKeys.contentTypeOrder, ascending: true},{field: OrderKeys.name, ascending: true}]
  };

  export const position: OptionDefinition = {
    id: 'position',
    field: OrderKeys.position,
    getMenuItemDisplayValue: Messages.sortFavoritePosition,
    getButtonDisplayValue: Messages.sortFavoritePosition,
    ascending: true,
    toOrderClauseArray: () => [Order.asc(OrderKeys.position)]
  };

  export const dateAdded: OptionDefinition = {
    id: 'dateAdded',
    getMenuItemDisplayValue: Messages.sortFavoriteDateAdded,
    subSortOptions: {
      'desc': {
        id: 'dateAdded.desc',
        field: OrderKeys.dateAdded,
        getMenuItemDisplayValue: Messages.sortByNewest,
        getButtonDisplayValue: Messages.sortFavoriteDateAddedNewest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.dateAdded)]
      },
      'asc': {
        id: 'dateAdded.asc',
        field: OrderKeys.dateAdded,
        getMenuItemDisplayValue: Messages.sortByOldest,
        getButtonDisplayValue: Messages.sortFavoriteDateAddedOldest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.dateAdded)]
      }
    }
  };

  export const jobId: OptionDefinition = {
    id: 'jobId',
    getMenuItemDisplayValue: Messages.column_backgroundJob_id,
    subSortOptions: {
      'asc': {
        id: 'jobId.asc',
        field: OrderKeys.jobId,
        getMenuItemDisplayValue: Messages.sortByLowest,
        getButtonDisplayValue: Messages.sortByIdAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.jobId)]
      },
      'desc': {
        id: 'jobId.desc',
        field: OrderKeys.jobId,
        getMenuItemDisplayValue: Messages.sortByHighest,
        getButtonDisplayValue: Messages.sortByIdDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.jobId)]
      }
    }
  };

  export const connectedApplicationClientId: OptionDefinition = {
    id: 'clientId',
    getMenuItemDisplayValue: Messages.connectedApplicationsClientId,
    subSortOptions: {
      'asc': {
        id: 'clientId.asc',
        field: OrderKeys.connectedApplicationClientId,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.connectedApplicationClientId)]
      },
      'desc': {
        id: 'clientId.desc',
        field: OrderKeys.connectedApplicationClientId,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.connectedApplicationClientId)]
      }
    }
  };

  export const connectedApplicationStatus: OptionDefinition = {
    id: 'enabled',
    getMenuItemDisplayValue: Messages.connectedApplicationsStatus,
    subSortOptions: {
      'asc': {
        id: 'enabled.asc',
        field: OrderKeys.connectedApplicationStatus,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.connectedApplicationStatus)]
      },
      'desc': {
        id: 'enabled.desc',
        field: OrderKeys.connectedApplicationStatus,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.connectedApplicationStatus)]
      }
    }
  };

  export const connectedApplicationScope: OptionDefinition = {
    id: 'scope',
    getMenuItemDisplayValue: Messages.connectedApplicationsScope,
    subSortOptions: {
      'asc': {
        id: 'scope.asc',
        field: OrderKeys.connectedApplicationScope,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.connectedApplicationScope)]
      },
      'desc': {
        id: 'scope.desc',
        field: OrderKeys.connectedApplicationScope,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.connectedApplicationScope)]
      }
    }
  };

  export const connectedApplicationDomains: OptionDefinition = {
    id: 'domains',
    getMenuItemDisplayValue: Messages.connectedApplicationsDomainSafelist,
    subSortOptions: {
      'asc': {
        id: 'domains.asc',
        field: OrderKeys.connectedApplicationDomains,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.connectedApplicationDomains)]
      },
      'desc': {
        id: 'domains.desc',
        field: OrderKeys.connectedApplicationDomains,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.connectedApplicationDomains)]
      }
    }
  };
}
